<template>
  <div>
    <checkout-component />
  </div>
</template>

<script>
import CheckoutComponent from '@/components/CheckoutComponent.vue';
export default {
  name: "CheckoutPage",
  components: { CheckoutComponent },
};
</script>

<style scoped>
</style>

